import React, { useEffect } from 'react';
import { X, Info } from '@phosphor-icons/react';
import { LandlordApplicationForm } from '../forms/LandlordApplicationForm';
import { cn } from '../../lib/utils';
interface OfferEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  mode: 'edit' | 'update-after-rejection';
  tenantName: string;
  tenantProfileId: string;
  onSuccess: () => void;
  navigate?: (page: string, context?: any) => void;
}
export function OfferEditModal({
  isOpen,
  onClose,
  mode,
  tenantName,
  tenantProfileId,
  onSuccess,
  navigate
}: OfferEditModalProps) {
  // Lock body scroll while open + ESC to close
  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', handleKey);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  const title = mode === 'edit' ? 'Editează oferta' : 'Trimite ofertă actualizată';
  const isUpdate = mode === 'update-after-rejection';
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center lg:pl-[16rem]" role="dialog" aria-modal="true" data-id="element-614">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-dark-1/70 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} data-id="element-615" />

      {/* Modal/Sheet */}
      <div className={cn('relative w-full sm:w-[560px] max-h-[90vh] flex flex-col', 'bg-dark-2 border border-dark-4', 'rounded-t-2xl sm:rounded-2xl', 'animate-in slide-in-from-bottom sm:zoom-in-95 sm:slide-in-from-bottom-0 fade-in duration-300', 'shadow-2xl')} data-id="element-616">
        {/* Drag handle (mobile only) */}
        <div className="sm:hidden flex justify-center pt-3 pb-1" data-id="element-617">
          <div className="w-10 h-1 rounded-full bg-dark-4" data-id="element-618" />
        </div>

        {/* Header */}
        <div className="px-6 pt-5 pb-4 border-b border-dark-4 shrink-0" data-id="element-619">
          <div className="flex items-start justify-between gap-3" data-id="element-620">
            <h2 className="text-lg font-semibold text-light-1" data-id="element-621">{title}</h2>
            <button type="button" onClick={onClose} className="text-light-3 hover:text-light-1 transition-colors -m-1 p-1 shrink-0" aria-label="Închide" data-id="element-622">
              <X size={22} weight="bold" data-id="element-623" />
            </button>
          </div>

          {isUpdate && <div className="mt-4 flex items-start gap-2 bg-lime-5 border border-lime-4 rounded-lg p-3" data-id="element-624">
              <Info size={16} className="text-lime-1 shrink-0 mt-0.5" data-id="element-625" />
              <p className="text-xs text-light-2" data-id="element-626">
                Răspunzi unei respingeri de la{' '}
                <span className="font-semibold text-light-1" data-id="element-627">{tenantName}</span>
                . Oferta nouă va fi trimisă separat, iar cea veche va rămâne în
                istoric.
              </p>
            </div>}
        </div>

        {/* Body — scrollable */}
        <div className="flex-1 overflow-y-auto px-6 py-6" data-id="element-628">
          <LandlordApplicationForm tenantProfileId={tenantProfileId} tenantName={tenantName} headerless navigate={navigate} onSuccess={() => {
          onSuccess();
          // Small delay to let the success state render before closing
          setTimeout(onClose, 1500);
        }} data-id="element-629" />
        </div>
      </div>
    </div>;
}